import React, { PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import Checkbox from '@bibliocommons/base-checkbox';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Info } from '@bibliocommons/base-icons';
import '../styles/DigitalAutoCheckouts.scss';

class EnableAutoCheckouts extends BcReactComponent {

  constructor(props) {
    super(props);

    this.state = {
      helpIsOpen: this.props.initialHelpIsOpen,
      isChecked: this.props.initialIsChecked
    };

    this.bindAll('toggleHelp', 'toggleAutoCheckouts');
  }

  toggleHelp(e) {
    if (e) { e.preventDefault(); }
    this.setState({ helpIsOpen: !this.state.helpIsOpen });
  }

  renderHelp() {
    const { intl } = this.props;
    if (this.state.helpIsOpen) {
      const helpInfo = intl.formatMessage({ id: 'enable_auto_checkout_info' });
      return (
        <div className="toggle-auto-checkouts-help" aria-expanded={this.state.helpIsOpen} aria-live="polite">
          {helpInfo}
        </div>
      );
    }
    return null;
  }

  toggleAutoCheckouts(checked) {
    this.setState({ isChecked: !this.state.isChecked });
    this.props.handleChange(checked);
  }

  render() {
    const { intl, supportAutoCheckout } = this.props;
    const helpInfoTriggerText = intl.formatMessage({ id: 'label_info' });
    const checkboxLabel = intl.formatMessage({ id: 'enable_auto_checkout' });

    if (supportAutoCheckout) {
      return (
        <div className="cp-digital-auto-checkouts">
          <Checkbox
            id="toggle-auto-checkouts"
            label={checkboxLabel}
            name="autoCheckout"
            checked={this.state.isChecked}
            inline
            handleChange={this.toggleAutoCheckouts}
            labelAfter />
          <a href="#toggle-help" onClick={this.toggleHelp} className="toggle-help-trigger">
            <Info /> {helpInfoTriggerText}
          </a>
          { this.renderHelp() }
        </div>
      );
    }
    return null;
  }
}

EnableAutoCheckouts.defaultProps = {
  initialHelpIsOpen: false,
  initialIsChecked: false,
  supportAutoCheckout: false
};

EnableAutoCheckouts.propTypes = {
  handleChange: PropTypes.func.isRequired,
  initialHelpIsOpen: PropTypes.bool,
  initialIsChecked: PropTypes.bool,
  supportAutoCheckout: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(EnableAutoCheckouts);



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-auto-checkouts/components/EnableAutoCheckouts.component.jsx